export const HR_ERRORS = {
  DEFAULT_VISIBLE_TEXT: '--',
  NOT_AVAILABLE: 'not available yet',
  NOT_EXISTS: 'not exist in HRA',
  HR_SERVER_RESPONSE_ERRROR_OFFLINE: 404,
};

export const CODE_ERRORS = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
  SERVER_DOWN_OR_NO_INTERNET: 0,
};

export const TIMEOUT = 'Connection timeout error';
